import { render, staticRenderFns } from "./CopperVerify.vue?vue&type=template&id=3d019506&scoped=true&"
import script from "./CopperVerify.vue?vue&type=script&lang=js&"
export * from "./CopperVerify.vue?vue&type=script&lang=js&"
import style0 from "./CopperVerify.vue?vue&type=style&index=0&id=3d019506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d019506",
  null
  
)

export default component.exports